import React, { useEffect, useState } from "react";
import Banner2 from "../components/Banner2";
import {
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import Contact from "../components/Contact";
import { Loader } from "../components/common/loader";
import {
  getQuote,
  getRop,
  getTravelProductType,
  sendVehicleInfoGig,
  updateTotalPrice,
  updateTransactionData,
  getEbridgeQuotes,
  resetEbridgeData,
} from "../features/product";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createFormData, formatOmanDate } from "../utils/commonHelper";
import { NoData } from "../components/common/NoData";
import { DynamicFormModal } from "../components/common/dynamic-form-modal";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthProvider";
import { GigCompanyCard } from "../components/GigCompany/CompanyCard";
import { AoCompanyCard } from "../components/AoCompany/CompanyCard";
import { TakafulCompanyCard } from "../components/TakafulCompany/CompanyCard";
import VehicleDetails from "../components/common/vehicle-details";
import { OquicCompanyCard } from "../components/OquicCompany/CompanyCard";
import { EbridgeCompanyCard } from "../components/EbridgeCompany/CompanyCard";
import { buildEbridgeQuoteRequest } from "../utils/ebridgeHelpers";
import TravelCard from "../components/common/travel-details";
import { getCliamInfo } from "../features/rop/ropSlice";
import Stepper from "../components/Stepper.js";

const MotorDetailsPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { ropRequestData, vehicleData, valuationData } = location.state || {};
  const selectedProduct = ropRequestData?.product || {};
  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : null;
  const [inputFormShow, setInputFormShow] = useState(false);
  const [inputParameters, setInputParameters] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const {
    companyList,
    companyLoader,
    status,
    quoteLoader,
    takafulInsuranceData,
    gigInsuranceData,
    aoInsuranceData,
    oquicInsuranceData,
    ebridgeInsuranceData,
    ebridgeLoader,
  } = useSelector((state) => state.product);
  const { cliamInfoLoader, cliamInfoData } = useSelector((state) => state.rop);
  const { ropLicense, ropVehicle } = vehicleData || {};
  const [ropInfoModalShow, setRopInfoModalShow] = useState(false);
  const { setModalIsOpen, setFromCheckout } = useAuth();
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(0);
  const [showGigPlans, setShowGigPlans] = useState(false);
  const [ebridgeRequested, setEbridgeRequested] = useState(false);
  console.log("Vechile infor", location.state || {});


  const handleCoverSelection = (e, companyId) => {
    if (e.target.checked) {
      dispatch(
        updateTotalPrice({
          value: e.target.value,
          customAction: "increment",
          id: companyId,
        })
      );
    } else {
      dispatch(
        updateTotalPrice({
          value: e.target.value,
          customAction: "decrement",
          id: companyId,
        })
      );
    }
  };

  const buyNowHandler = (item) => {
    localStorage.setItem(
      "product_detail",
      JSON.stringify({
        productName: item?.sub_product_name,
        companyName: item?.insurance_company_name,
        price: item?.fixed_rate_value,
      })
    );

    if (token) {
      if (
        item &&
        item?.api_input_parameters &&
        item?.api_input_parameters?.length
      ) {
        setSelectedCompany(item);
        setInputFormShow(true);
        setInputParameters(item?.api_input_parameters);
      } else {
        dispatch(
          getQuote({
            ...item?.extracted_data,
            insurance_company_product_mapping_id: item?.id,
          })
        ).then(() => {
          navigate("/checkout");
        });
      }
    } else {
      // navigate('/signin', { state: { fromCheckout: true } });
      setFromCheckout(true);
      setModalIsOpen(true);
    }
  };



  const buyNowTakafulInsurance = (data) => {
    // ✅ compute loading flags once
    const loadings = {
      nil_excess_loading: data.optional_covers?.[0]?.isSelected ? "Yes" : "No",
      sport_activity_loading: data.optional_covers?.[1]?.isSelected ? "Yes" : "No",
      top_up_benefits_loading: data.optional_covers?.[2]?.isSelected ? "Yes" : "No",
    };

    // ✅ create a NEW extensible object
    const updatedData = {
      ...data,
      ...loadings,
      extracted_data: {
        ...data.extracted_data,
        ...loadings,
      },
    };

    // ✅ redux update (safe)
    dispatch(
      updateTransactionData({
        business_status: "BUY-NOW",
        insurance_company: updatedData?.company_name,
      })
    );


    // ✅ navigation with SAFE data
    if (
      updatedData?.product_id === 1 &&
      (updatedData?.sub_product_id === 1 ||
        updatedData?.sub_product_id === 21)
    ) {
      navigate("/takaful-motor-personal-detail-form", {
        state: { data: updatedData },
      });
    } else {
      const extracted_data = updatedData?.extracted_data;

      const prefilledCounts = {
        "no_of_adults_-_(age_18_or_above)":
          parseInt(extracted_data?.["no_of_adults_-_(age_18_or_above)"]) || 0,
        "no_of_child_-_(age_16_or_below)":
          parseInt(extracted_data?.["no_of_child_-_(age_16_or_below)"]) || 0,
        "no_of_child_-_(age_17_to_18)":
          parseInt(extracted_data?.["no_of_child_-_(age_17_to_18)"]) || 0,
        "no_of_seniors_-_(age_71_to_79)":
          parseInt(extracted_data?.["no_of_seniors_-_(age_71_to_79)"]) || 0,
      };

      navigate("/takaful-personal-detail-form", {
        state: { prefillCounts: prefilledCounts, data },
      });
    }
  };

  const buyNowGigInsurance = (data) => {
    dispatch(
      updateTransactionData({
        business_status: "BUY-NOW",
        insurance_company: data?.company_name
      })
    )
    if (
      data?.product_id === 1 &&
      (data?.sub_product_id === 1 || data?.sub_product_id === 21)
    ) {
      // console.log("vechild atas ",vehicleData);
      dispatch(sendVehicleInfoGig(vehicleData));
      //for motor product
      navigate("/gig-motor-personal-detail-form", { state: { data } });
    } else {
      //for travel product
      const extracted_data = data?.extracted_data;
      const prefilledCounts = {
        "no_of_adults_-_(age_18_or_above)":
          parseInt(extracted_data["no_of_adults_-_(age_18_or_above)"]) ?? 0,
        "no_of_child_-_(age_16_or_below)":
          parseInt(extracted_data["no_of_child_-_(age_16_or_below)"]) ?? 0,
        "no_of_child_-_(age_17_to_18)":
          parseInt(extracted_data["no_of_child_-_(age_17_to_18)"]) ?? 0,
        "no_of_seniors_-_(age_71_to_79)":
          parseInt(extracted_data["no_of_seniors_-_(age_71_to_79)"]) ?? 0,
      };
      navigate("/gig-personal-detail-form", {
        state: { prefillCounts: prefilledCounts, data },
      });
    }
  };

  const buyNowAoInsurance = (data) => {
    dispatch(
      updateTransactionData({
        business_status: "BUY-NOW",
        insurance_company: data?.company_name
      })
    )
    const extracted_data = data?.extracted_data;
    const prefilledCounts = {
      "no_of_adults_-_(age_18_or_above)":
        parseInt(extracted_data["no_of_adults_-_(age_18_or_above)"]) ?? 0,
      "no_of_child_-_(age_16_or_below)":
        parseInt(extracted_data["no_of_child_-_(age_16_or_below)"]) ?? 0,
      "no_of_child_-_(age_17_to_18)":
        parseInt(extracted_data["no_of_child_-_(age_17_to_18)"]) ?? 0,
      "no_of_seniors_-_(age_71_to_79)":
        parseInt(extracted_data["no_of_seniors_-_(age_71_to_79)"]) ?? 0,
    };
    navigate("/ao-personal-detail-form", {
      state: { prefillCounts: prefilledCounts, data },
    });
  };

  const buyNowEbridgeInsurance = (data) => {
    localStorage.setItem(
      "product_detail",
      JSON.stringify({
        productName: data?.sub_product_id === 21 ? "Comprehensive" : "Third Party",
        companyName: data?.company_name,
        price: data?.premium_value,
      })
    );
    dispatch(
      updateTransactionData({
        business_status: "BUY-NOW",
        insurance_company: data?.company_name,
        is_rpa: true,
        premium_amount: data?.premium_value,
      })
    );
    navigate("/checkout", {
      state: {
        existingData: {
          is_ebridge: true,
          targetCode: data?.company_code,
          company_name: data?.company_name,
          company_id: data?.company_code,
          premium_value: data?.premium_value,
          premium_currency: "OMR",
          quote_reference: data?.quote_reference,
          planData: data,
        },
      },
    });
  };

  const buyNowOquicInsurance = (data) => {
    dispatch(
      updateTransactionData({
        business_status: "BUY-NOW",
        insurance_company: data?.company_name
      })
    )
    if (
      data?.product_id === 1 &&
      (data?.sub_product_id === 1 || data?.sub_product_id === 21)
    ) {
      //for motor product
      navigate("/oquic-motor-personal-detail-form", { state: { data } });
    } else {
      //for travel product
      const extracted_data = data?.extracted_data;
      const prefilledCounts = {
        "total_adults_(age_18_or_above)":
          (parseInt(extracted_data["no_of_adults_-_(age_18_or_above)"]) || 0) +
          (parseInt(extracted_data["no_of_seniors_-_(age_71_to_79)"]) || 0),
        "total_childs_(age_18_below)":
          (parseInt(extracted_data["no_of_child_-_(age_16_or_below)"]) || 0) +
          (parseInt(extracted_data["no_of_child_-_(age_17_to_18)"]) || 0),
      };
      navigate("/oquic-personal-detail-form", {
        state: { prefillCounts: prefilledCounts, data },
      });
    }
  };

  const handleSubmit = (event, data) => {
    event.preventDefault();
    const convertedFormData = createFormData(data);
    convertedFormData.append(
      "insurance_company_product_mapping_id",
      selectedCompany?.id
    );
    const convertedExtractedData = createFormData(
      selectedCompany?.extracted_data
    );
    for (const [key, value] of convertedExtractedData.entries()) {
      convertedFormData.append(key, value);
    }
    dispatch(getQuote(convertedFormData)).then(() => {
      navigate("/checkout");
    });
  };

  useEffect(() => {
    if (ropRequestData) {
      dispatch(getRop(ropRequestData));
      const timer = setTimeout(() => {
        dispatch(getRop(ropRequestData));
        const vehicleInfo = vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
          ?.GetVehicleValuationByPlateResult?.VehicleInfo;
        dispatch(
          updateTransactionData({
            chassis_no: vehicleInfo?.ChassisNumber,
            engine_no: vehicleInfo?.EngineNumber,
            plate_no: vehicleInfo?.PlateNumber,
            plate_character: vehicleInfo?.PlateCode,
            vehicle_make: vehicleInfo?.VehicleMakeDesc,
            vehicle_model: vehicleInfo?.VehicleModelDesc
          })
        )
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [dispatch, status, ropRequestData]);

  useEffect(() => {
    //Display user Details Data which comes from rop api
    if (ropLicense) {
      setRopInfoModalShow(true);
    }
  }, [ropLicense, status]);

  useEffect(() => {
    let value = ropRequestData?.form_data?.area_of_coverage;
    if (value) {
      dispatch(getTravelProductType(value));
    }
  }, [ropRequestData?.form_data?.area_of_coverage]);

  const handleLoadEbridgeQuotes = () => {
    setEbridgeRequested(true);
    const requestData = buildEbridgeQuoteRequest(
      ropRequestData,
      vehicleData,
      valuationData
    );
    const promise = dispatch(
      getEbridgeQuotes({
        requestData,
        productDetails: ropRequestData?.product_details,
      })
    );
    return promise;
  };

  useEffect(() => {
    return () => {
      dispatch(resetEbridgeData());
      setEbridgeRequested(false);
    };
  }, []);

  useEffect(() => {
    //for GIG Motor Comprehensive product put cliam info service validation
    if (
      ropRequestData &&
      ropRequestData?.product_details &&
      ropRequestData?.product_details?.product_id === 1 &&
      ropRequestData?.product_details?.sub_product_id === 21
    ) {
      const license_no =
        ropLicense?.Body?.GetLicenseInfoResponse?.GetLicenseInfoResult
          ?.LicenseNumber;

      // console.log({ ropRequestData, ropLicense, license_no });

      dispatch(
        getCliamInfo({
          license_no,
          language: currentLanguage === "ar" ? "Arb" : "Eng",
        })
      );
    }
  }, [currentLanguage]);

  useEffect(() => {
    //for GIG Motor Comprehensive product put cliam info service validation
    console.log("Pridycgcx ", vehicleData);

    if (
      selectedProduct &&
      selectedProduct?.id === 1 &&
      cliamInfoData &&
      cliamInfoData?.ClaimCountByLicenseNoResponse?.ClaimCountByLicenseNoResult
        ?.diffgram?.NewDataSet?.Table?.SecondParty
    ) {
      // console.log(cliamInfoData);
      const secondParty =
        cliamInfoData?.ClaimCountByLicenseNoResponse
          ?.ClaimCountByLicenseNoResult?.diffgram?.NewDataSet?.Table
          ?.SecondParty;
      if (Number(secondParty) > 0) {
        setShowGigPlans(false);
      } else {
        setShowGigPlans(true);
      }
    } else {
      setShowGigPlans(true);
    }
  }, [cliamInfoData]);

  return (
    <>
      <div className="motorDetails">

        {/* <Stepper currentStep={2} /> */}
        <Banner2>
          <Container fluid className="px-0">
            <Row>
              {/* <Col md={12}> */}
              {/* <div className="details-title ">
                  <h3 className="title text-capitalize">
                    {currentLanguage == 'ar' ? "أحصل على عروض أسعار تأمين السيارت/ المركبات" : t("getQuoteTitle", {
                      product_name: ropRequestData?.product?.product_name,
                    })}
                  </h3>
                </div> */}
              {ropRequestData?.product?.id === 1 ? (
                <VehicleDetails
                  ropLicense={ropLicense}
                  ropVehicle={ropVehicle}
                  valuationData={valuationData}
                  selectedProduct={ropRequestData?.product_details}
                />
              ) : ropRequestData?.product?.id === 15 ? (
                <TravelCard data={ropRequestData?.form_data} />
              ) : (
                ""
              )}
              {companyLoader || quoteLoader || cliamInfoLoader ? (
                <Loader type="logo-gif" />
              ) : companyList && companyList.length ? (
                companyList.map((item, index) => (
                  <div
                    className="policy-formBox details-box airplane"
                    key={"company_list_" + index}
                  >
                    <div className="header-details airplane">
                      <div className="logo-text">
                        <img
                          src={
                            item?.insurance_company?.image ??
                            require("../assets/images/takaful-logo.png")
                          }
                          alt="logo"
                          className="img-fluid"
                        ></img>
                        <div className="logo-text-content">
                          <Button className="btn h-btn">
                            {t("idvCover")} - 3,26,400
                          </Button>
                        </div>
                      </div>
                      <div>
                        <Button className="btn h-btn">
                          {t("basePrice")} : {item?.fixed_rate_value}
                        </Button>
                      </div>
                    </div>
                    <div className="main-details">
                      <Row>
                        <Col md={4}>
                          <div className="details-item">
                            <ul className="horizontal-list">
                              {item?.cover_mapping &&
                                item?.cover_mapping.length ? (
                                <>
                                  <h5 className="title">
                                    {t("includedcovers")}
                                  </h5>
                                  {item.cover_mapping.map(
                                    (cover_item, coverIndex) => (
                                      <li
                                        key={`cover_master_${coverIndex}`}
                                        onClick={(e) =>
                                          handleCoverSelection(
                                            cover_item?.rate || 0,
                                            item?.id
                                          )
                                        }
                                      >
                                        {cover_item?.cover_name}
                                      </li>
                                    )
                                  )}
                                </>
                              ) : (
                                <li>
                                  <NoData msg={t("noCoverMsg")} />
                                </li>
                              )}
                            </ul>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    {item?.extracted_data &&
                      item?.extracted_data?.plans &&
                      item?.extracted_data?.plans.length ? (
                      <div className="main-details  px-5">
                        <div className="details-item">
                          <h5 className="title">{t("plans")}</h5>
                          <ul className="horizontal-list">
                            {item?.extracted_data?.plans.map(
                              (plan, plan_index) => (
                                <li
                                  className={
                                    plan_index === selectedPlanIndex
                                      ? "active"
                                      : ""
                                  }
                                  key={`plans_${plan_index}`}
                                  onClick={() => {
                                    setSelectedPlanIndex(plan_index);
                                    dispatch(
                                      updateTotalPrice({
                                        value:
                                          plan?.premium?.grossPremium?.amount,
                                        customAction: "flat",
                                        id: item?.id,
                                      })
                                    );
                                  }}
                                >
                                  {plan?.product?.value} (
                                  {plan?.premium?.grossPremium?.amount})
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="details-footer">
                      <div className="detailsfooter-item">
                        <h4 className="title">
                          {t("totalPayment")}: {item?.fixed_rate_value}
                        </h4>
                        <Button
                          className="btn h-btn"
                          onClick={() => buyNowHandler(item)}
                        >
                          {t("buyNow")}
                        </Button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                ""
              )}
              <Row className="px-md-5 mx-md-0 mx-2 margin-set">
                {!(companyLoader || quoteLoader || cliamInfoLoader) &&
                  takafulInsuranceData &&
                  takafulInsuranceData?.length
                  ? takafulInsuranceData.map((data, index) =>
                    data?.premium_value === 0 ? (
                      ""
                    ) : (
                      <Col xs={12} sm={12} md={4} key={index} className="mb-4">
                        <TakafulCompanyCard
                          key={"takaful_insurance_data_" + index}
                          data={data}
                          ropRequestData={ropRequestData}
                          buyNowHandler={buyNowTakafulInsurance}
                        />
                      </Col>
                    )
                  )
                  : ""}
                {!(companyLoader || quoteLoader || cliamInfoLoader) &&
                  showGigPlans &&
                  gigInsuranceData &&
                  gigInsuranceData?.length
                  ? gigInsuranceData.map((data, index) =>
                    data?.premium_value === 0 ? (
                      ""
                    ) : (
                      <Col xs={12} sm={12} md={4} key={index} className="mb-4">
                        <GigCompanyCard
                          key={"gig_insurance_data_" + index}
                          data={data}
                          buyNowHandler={buyNowGigInsurance}
                        />
                      </Col>
                    )
                  )
                  : ""}
                {!(companyLoader || quoteLoader || cliamInfoLoader) &&
                  aoInsuranceData &&
                  aoInsuranceData?.length
                  ? aoInsuranceData.map((data, index) =>
                    data?.premium_value === 0 ? (
                      ""
                    ) : (
                      <Col xs={12} sm={12} md={4} key={index} className="mb-4">
                        <AoCompanyCard
                          key={"ao_insurance_data_" + index}
                          data={data}
                          buyNowHandler={buyNowAoInsurance}
                        />
                      </Col>
                    )
                  )
                  : ""}
                {!(companyLoader || quoteLoader || cliamInfoLoader) &&
                  oquicInsuranceData &&
                  oquicInsuranceData?.length
                  ? oquicInsuranceData.map((data, index) =>
                    data?.premium_value === 0 ? (
                      ""
                    ) : (
                      <Col xs={12} sm={12} md={4} key={index} className="mb-4">
                        <OquicCompanyCard
                          key={"oquic_insurance_data_" + index}
                          data={data}
                          ropRequestData={ropRequestData}
                          buyNowHandler={buyNowOquicInsurance}
                        />
                      </Col>
                    )
                  )
                  : ""}
                {/* {!(companyLoader || quoteLoader || cliamInfoLoader) && (
                  !ebridgeRequested ? (
                    <Col xs={12} className="mb-4">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "14px 20px",
                          background: "#fff8e7",
                          borderRadius: 10,
                          border: "2px dashed #f0a500",
                          cursor: "pointer",
                        }}
                        onClick={handleLoadEbridgeQuotes}
                      >
                        <span style={{ color: "#b07800", fontWeight: 600, fontSize: 15 }}>
                          ✦ We have more options available — Click to explore
                        </span>
                      </div>
                    </Col>
                  ) : ebridgeLoader ? (
                    <Col xs={12} className="mb-4">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          padding: "16px 20px",
                          background: "#fff8e7",
                          borderRadius: 10,
                          border: "1px solid #f0a500",
                        }}
                      >
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                          style={{ color: "#f0a500" }}
                        />
                        <span style={{ color: "#b07800", fontWeight: 500 }}>
                          Loading policies for you, please wait...
                        </span>
                      </div>
                    </Col>
                  ) : ebridgeInsuranceData && ebridgeInsuranceData.length ? (
                    ebridgeInsuranceData.map((data, index) =>
                      data?.premium_value === 0 ? null : (
                        <Col xs={12} sm={12} md={4} key={index} className="mb-4">
                          <EbridgeCompanyCard
                            key={"ebridge_insurance_data_" + index}
                            data={data}
                            buyNowHandler={buyNowEbridgeInsurance}
                          />
                        </Col>
                      )
                    )
                  ) : null
                )} */}
                {!(
                  takafulInsuranceData?.length ||
                  gigInsuranceData?.length ||
                  aoInsuranceData?.length ||
                  oquicInsuranceData?.length
                ) && !(companyLoader || quoteLoader || cliamInfoLoader) ? (
                  <NoData msg={t("noCompanySelection")} />
                ) : null}
                {/* </Col> */}
              </Row>
            </Row>

          </Container>
        </Banner2>
        <Contact />
        <DynamicFormModal
          show={inputFormShow}
          handleClose={() => setInputFormShow(false)}
          inputParameters={inputParameters}
          handleSubmit={handleSubmit}
        />

        {/* //add condition if product_id=1 then this modal need to display */}
        {selectedProduct && selectedProduct?.id === 1 && (
          <Modal
            size="xl"
            show={ropInfoModalShow}
            onHide={() => setRopInfoModalShow(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{t("ropInfoModalTitle")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-scroll">
              {/* License Information */}
              <Card className="mb-3">
                <Card.Header className="bg-gold text-dark">
                  {t("licence-info")}
                </Card.Header>
                <Card.Body>
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td>
                          <strong>{t("licence-number")}</strong>
                        </td>
                        <td>
                          {ropLicense?.Body?.GetLicenseInfoResponse
                            ?.GetLicenseInfoResult?.LicenseNumber || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("first-issue")}</strong>
                        </td>
                        <td>
                          {formatOmanDate(
                            ropLicense?.Body?.GetLicenseInfoResponse
                              ?.GetLicenseInfoResult?.DateFirstIssued
                          ) || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("place-issue")}</strong>
                        </td>
                        <td>
                          {ropLicense?.Body?.GetLicenseInfoResponse
                            ?.GetLicenseInfoResult?.PlaceOfIssue || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("date-expiry")}</strong>
                        </td>
                        <td>
                          {formatOmanDate(
                            ropLicense?.Body?.GetLicenseInfoResponse
                              ?.GetLicenseInfoResult?.DateofExpiry
                          ) || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("licence-class")}</strong>
                        </td>
                        <td>
                          {ropLicense?.Body?.GetLicenseInfoResponse
                            ?.GetLicenseInfoResult?.LicenseClass?.string ||
                            "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>

              {/* Vehicle Information */}
              <Card>
                <Card.Header className="bg-gold text-dark">
                  {t("vehicle-info")}
                </Card.Header>
                <Card.Body>
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td>
                          <strong>{t("plate-number")}</strong>
                        </td>
                        <td>
                          {ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                            ?.GetVehicleValuationByPlateResult?.VehicleInfo
                            ?.PlateNumber || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("chassis-number")}</strong>
                        </td>
                        <td>
                          {ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                            ?.GetVehicleValuationByPlateResult?.VehicleInfo
                            ?.ChassisNumber || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("engine-number")}</strong>
                        </td>
                        <td>
                          {ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                            ?.GetVehicleValuationByPlateResult?.VehicleInfo
                            ?.EngineNumber || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("make-year")}</strong>
                        </td>
                        <td>
                          {ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                            ?.GetVehicleValuationByPlateResult?.VehicleInfo
                            ?.MakeYear || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("vehicle-modal")}</strong>
                        </td>
                        <td>
                          {ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                            ?.GetVehicleValuationByPlateResult?.VehicleInfo
                            ?.VehicleModelDesc || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("color")}</strong>
                        </td>
                        <td>
                          {ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                            ?.GetVehicleValuationByPlateResult?.VehicleInfo
                            ?.ColorDesc || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("insurance-type")}</strong>
                        </td>
                        <td>
                          {ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                            ?.GetVehicleValuationByPlateResult?.VehicleInfo
                            ?.InsuranceTypeDesc || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("current-insurer")}</strong>
                        </td>
                        <td>
                          {ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                            ?.GetVehicleValuationByPlateResult?.VehicleInfo
                            ?.InsuranceCompanyName || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{t("current-insurance-expiry")}</strong>
                        </td>
                        <td>
                          {formatOmanDate(
                            ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                              ?.GetVehicleValuationByPlateResult?.VehicleInfo
                              ?.InsuranceEndDate
                          ) || "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="h-btn"
                onClick={() => setRopInfoModalShow(false)}
              >
                {t("continue")}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  );
};

export default MotorDetailsPage;
